
import type { ReactNode } from "react";

interface ContentHostProps {
  children: ReactNode;
}

export function ContentHost({ children }: ContentHostProps) {
  return <main className="content-host">{children}</main>;
}